function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1956(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27.58,
    height: 15.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.254285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 7.89
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.78,
    width: 27.58,
    height: 17.62,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.936666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 24.59
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.39,
    width: 27.58,
    height: 23.15,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.7875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 44.965
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.55,
    width: 27.58,
    height: 24.16,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.832
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 68.63
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.7,
    width: 27.58,
    height: 26.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 93.89
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107.09,
    width: 27.58,
    height: 28.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 121.32000000000001
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.54,
    width: 27.58,
    height: 29.16,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0644444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 150.12
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 164.7,
    width: 27.58,
    height: 31.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.596666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 180.255
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 195.81,
    width: 27.58,
    height: 35.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 213.565
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 231.32,
    width: 27.58,
    height: 36.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.516
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 249.35999999999999
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 267.4,
    width: 27.58,
    height: 37.45,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 286.125
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 304.85,
    width: 27.58,
    height: 41.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 325.64500000000004
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 346.44,
    width: 27.58,
    height: 45.42,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.758
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 369.15
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 391.86,
    width: 27.58,
    height: 48.85,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.596666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 416.285
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 440.71,
    width: 27.58,
    height: 49.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.596666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 465.46
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 490.21,
    width: 27.58,
    height: 51.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0644444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 515.885
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 541.56,
    width: 27.58,
    height: 52.39,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 567.755
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 593.95,
    width: 27.58,
    height: 52.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.596666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 620.25
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 646.55,
    width: 27.58,
    height: 53.45,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.596666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.79,
    y: 673.275
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 0,
    width: 36.17,
    height: 42.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.167142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.665,
    y: 21.34
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.75,
    y: 0,
    width: 37.62,
    height: 42.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.523999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.56,
    y: 21.34
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.37,
    y: 0,
    width: 37.84,
    height: 42.68,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3066666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.29,
    y: 21.34
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.21,
    y: 0,
    width: 41.49,
    height: 42.68,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.18625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.955,
    y: 21.34
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.71,
    y: 0,
    width: 47.18,
    height: 42.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.268
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.3,
    y: 21.34
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.89,
    y: 0,
    width: 49.03,
    height: 42.68,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 252.40499999999997,
    y: 21.34
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.92,
    y: 0,
    width: 49.14,
    height: 42.68,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.49,
    y: 21.34
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.05,
    y: 0,
    width: 50.95,
    height: 42.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.52500000000003,
    y: 21.34
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377,
    y: 0,
    width: 51.59,
    height: 42.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.795,
    y: 21.34
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.59,
    y: 0,
    width: 52.58,
    height: 42.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.88,
    y: 21.34
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.17,
    y: 0,
    width: 52.69,
    height: 42.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 507.515,
    y: 21.34
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.86,
    y: 0,
    width: 53.93,
    height: 42.68,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.742222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.825,
    y: 21.34
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.8,
    y: 0,
    width: 55.35,
    height: 42.68,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.4749999999999,
    y: 21.34
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.15,
    y: 0,
    width: 56.85,
    height: 42.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.5749999999999,
    y: 21.34
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 42.68,
    width: 54.7,
    height: 46.8,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 66.08
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 89.48,
    width: 54.7,
    height: 46.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.653333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 112.96000000000001
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 136.44,
    width: 54.7,
    height: 47.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.913333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 160.18
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 183.93,
    width: 54.7,
    height: 48.55,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.091666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 208.205
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 232.48,
    width: 54.7,
    height: 49.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 257.2
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 281.91,
    width: 54.7,
    height: 49.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.954
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 306.68
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 331.46,
    width: 54.7,
    height: 49.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 356.34499999999997
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 381.23,
    width: 54.7,
    height: 50.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.632222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 406.57500000000005
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 431.92,
    width: 54.7,
    height: 51.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 457.56
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 483.2,
    width: 54.7,
    height: 51.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.312000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 508.98
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 534.76,
    width: 54.7,
    height: 52.85,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 561.185
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 587.6,
    width: 54.7,
    height: 56.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.814285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 615.61
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.58,
    y: 643.63,
    width: 54.7,
    height: 56.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.558333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.93,
    y: 671.8149999999999
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 42.68,
    width: 51.83,
    height: 62.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.47875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.20500000000001,
    y: 73.825
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.11,
    y: 42.68,
    width: 52.85,
    height: 62.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.808333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.53500000000003,
    y: 73.825
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.96,
    y: 42.68,
    width: 53.04,
    height: 62.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.577142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.48000000000002,
    y: 73.825
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 42.68,
    width: 53.18,
    height: 62.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.597142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.59,
    y: 73.825
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293.19,
    y: 42.68,
    width: 53.7,
    height: 62.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.671428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.04,
    y: 73.825
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.88,
    y: 42.68,
    width: 54.04,
    height: 62.29,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.9,
    y: 73.825
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.93,
    y: 42.68,
    width: 55.94,
    height: 62.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.323333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.9,
    y: 73.825
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.87,
    y: 42.68,
    width: 57.84,
    height: 62.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.79,
    y: 73.825
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.71,
    y: 42.68,
    width: 61.02,
    height: 62.29,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.22,
    y: 73.825
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.73,
    y: 42.68,
    width: 61.68,
    height: 62.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.57,
    y: 73.825
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.41,
    y: 42.68,
    width: 62.59,
    height: 62.29,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.381666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.7049999999999,
    y: 73.825
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 104.97,
    width: 63.19,
    height: 62.61,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.885,
    y: 136.275
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 167.58,
    width: 63.19,
    height: 63.2,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.89875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.885,
    y: 199.18
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 230.78,
    width: 63.19,
    height: 64.33,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.021111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.885,
    y: 262.945
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 295.11,
    width: 63.19,
    height: 64.83,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.885,
    y: 327.52500000000003
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 359.94,
    width: 63.19,
    height: 65.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.89875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.885,
    y: 392.74
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 425.54,
    width: 63.19,
    height: 66.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.885,
    y: 458.69500000000005
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 491.85,
    width: 63.19,
    height: 67.23,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.89875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.885,
    y: 525.465
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 559.08,
    width: 63.19,
    height: 67.9,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.027142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.885,
    y: 593.0300000000001
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.29,
    y: 626.98,
    width: 63.19,
    height: 73.02,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.885,
    y: 663.49
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.47,
    y: 104.97,
    width: 60.36,
    height: 77.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.65,
    y: 143.825
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.84,
    y: 104.97,
    width: 61.78,
    height: 77.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.825714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.73000000000002,
    y: 143.825
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.61,
    y: 104.97,
    width: 67.49,
    height: 77.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.641428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.355,
    y: 143.825
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 104.97,
    width: 68.35,
    height: 77.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.27500000000003,
    y: 143.825
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.45,
    y: 104.97,
    width: 71.66,
    height: 77.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.962222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.28,
    y: 143.825
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.11,
    y: 104.97,
    width: 71.96,
    height: 77.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.09000000000003,
    y: 143.825
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.06,
    y: 104.97,
    width: 75.1,
    height: 77.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.728571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.6099999999999,
    y: 143.825
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 622.16,
    y: 104.97,
    width: 77.84,
    height: 77.71,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.4275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.0799999999999,
    y: 143.825
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.47,
    y: 182.68,
    width: 74.58,
    height: 82.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.654285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.76,
    y: 223.70000000000002
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.47,
    y: 264.71,
    width: 74.58,
    height: 83.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.3225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.76,
    y: 306.27
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.47,
    y: 347.83,
    width: 74.58,
    height: 86.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.458
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.76,
    y: 391.26
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.47,
    y: 434.69,
    width: 74.58,
    height: 87.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.286666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.76,
    y: 478.33
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.47,
    y: 521.97,
    width: 74.58,
    height: 87.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.458
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.76,
    y: 565.83
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.47,
    y: 609.69,
    width: 74.58,
    height: 90.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.916
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.76,
    y: 654.845
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 182.68,
    width: 76.8,
    height: 95.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.799999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.45,
    y: 230.19
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.85,
    y: 182.68,
    width: 77.04,
    height: 95.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.840000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.37,
    y: 230.19
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.9,
    y: 182.68,
    width: 78.28,
    height: 95.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.03999999999996,
    y: 230.19
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.18,
    y: 182.68,
    width: 79.14,
    height: 95.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.914
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.75,
    y: 230.19
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.31,
    y: 182.68,
    width: 81.45,
    height: 95.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.635714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.035,
    y: 230.19
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 612.77,
    y: 182.68,
    width: 87.23,
    height: 95.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.930000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 656.385,
    y: 230.19
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 277.7,
    width: 85.8,
    height: 97.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.95,
    y: 326.26
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 374.82,
    width: 85.8,
    height: 105.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.95,
    y: 427.685
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 480.55,
    width: 85.8,
    height: 106.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.95,
    y: 533.5550000000001
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 586.56,
    width: 85.8,
    height: 113.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.95,
    y: 643.28
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.85,
    y: 277.7,
    width: 92.73,
    height: 118.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.59125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.21500000000003,
    y: 337.01
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.57,
    y: 277.7,
    width: 95.9,
    height: 118.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.983333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.52,
    y: 337.01
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.48,
    y: 277.7,
    width: 96.83,
    height: 118.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.366
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.895,
    y: 337.01
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.31,
    y: 277.7,
    width: 108.69,
    height: 118.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.527142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.655,
    y: 337.01
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.85,
    y: 396.32,
    width: 98.91,
    height: 143.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.305,
    y: 468.21
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.85,
    y: 540.1,
    width: 98.91,
    height: 159.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.7275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.305,
    y: 620.0500000000001
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.76,
    y: 396.32,
    width: 141.7,
    height: 123.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.46375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.61,
    y: 458.175
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.45,
    y: 396.32,
    width: 153.55,
    height: 123.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.672857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.225,
    y: 458.175
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.76,
    y: 520.03,
    width: 127.77,
    height: 179.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.97125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.645,
    y: 610.015
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.53,
    y: 520.03,
    width: 167.47,
    height: 179.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.224545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.265,
    y: 610.015
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1956);
export default __webpack_public_path__ + "static/media/1956.722ca545ab74d140ce293a394df08acb.svg";
export { ForwardRef as ReactComponent };